import React, { Component } from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const footerSections = [{
    title: 'Product',
    links: [{
      name: 'Product',
      href: '/#product'
    }, {
      name: 'Components',
      href: '/#components'
    }, {
      name: 'Platform',
      href: '/#platform'
    }, {
      name: 'Security',
      href: '/#security'
    }]
  }, {
    title: 'Community',
    links: [{
      name: 'Join Community',
      href: '/community',
      isRouterLink: true
    }, {
      name: 'About',
      href: '/',
      isRouterLink: true
    }, {
      name: 'Contact',
      href: 'mailto:support@fluid-form.ai'
    }]
  }, {
    title: 'Legal',
    links: [{
      name: 'Terms of Use',
      href: '/terms',
      isRouterLink: true
    }, {
      name: 'Privacy Policy',
      href: '/privacy',
      isRouterLink: true
    }]
  }];
  return <footer className="w-full bg-gray-900 text-gray-300 py-12 sm:py-14 md:py-16" data-id="element-452">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-453">
        <div className="flex flex-col md:flex-row justify-between mb-16 sm:mb-20 md:mb-24 gap-8 sm:gap-10 md:gap-12" data-id="element-454">
          <div className="md:w-1/3" data-id="element-455">
            <Link to="/" className="flex items-center mb-6 sm:mb-8 group" data-id="element-456">
              <img src="https://cdn.magicpatterns.com/uploads/fMJnv7yQ9EawQ6b54Tnvxq/FWLogo.png" alt="FluidWeb Logo" className="h-7 sm:h-8 transition-opacity group-hover:opacity-80" data-id="element-457" />
            </Link>
            <p className="text-gray-500 leading-relaxed mb-6 text-base sm:text-lg max-w-sm" data-id="element-458">
              Production-ready agentic interfaces for your product. You define
              what AI can do, when it can do it, and how it's verified.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 sm:gap-10 md:gap-12 md:w-2/3" data-id="element-459">
            {footerSections.map((section, index) => <div key={index} data-id="element-460">
                <h3 className="text-xs sm:text-sm font-bold text-white uppercase tracking-wider mb-4 sm:mb-6" data-id="element-461">
                  {section.title}
                </h3>
                <ul className="space-y-3 sm:space-y-4" data-id="element-462">
                  {section.links.map((link, linkIndex) => <li key={linkIndex} data-id="element-463">
                      {link.isRouterLink ? <Link to={link.href} className="text-gray-500 hover:text-white transition-colors text-sm sm:text-base min-h-[44px] inline-flex items-center" data-id="element-464">
                          {link.name}
                        </Link> : <a href={link.href} className="text-gray-500 hover:text-white transition-colors text-sm sm:text-base min-h-[44px] inline-flex items-center" data-id="element-465">
                          {link.name}
                        </a>}
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 sm:pt-10 md:pt-12 flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-6" data-id="element-466">
          <p className="text-gray-400 text-xs sm:text-sm text-center sm:text-left" data-id="element-467">
            © {currentYear} FluidWeb, Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-468">
            <span className="flex items-center gap-2 text-xs sm:text-sm text-gray-500" data-id="element-469">
              <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-470"></span>
              Systems Operational
            </span>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;